import Image from '../../Image';
import Link from '../../Link';
import { ISportCard } from '../../interfaces';

export default function SelectCard({ sport }: { sport: ISportCard }): JSX.Element {
    const disabledSport = sport.title === 'BÁSQUETBOL';
    return (
        <Link to={disabledSport ? '#' : sport.url} href={disabledSport ? '#' : sport.url}>
            <div
                className={`cursor-pointer flex flex-col mb-4 md:mb-0 ${
                    disabledSport ? 'opacity-50' : 'sport-zoom'
                }  snap-center`}
                style={{ maxWidth: 400 }}
            >
                <Image src={sport.image} alt={sport.alt} />
                <div
                    className={`${
                        disabledSport
                            ? 'block md:opacity-0 md:hover:opacity-100 transition  ease-in-out duration-700  absolute w-80'
                            : 'md:opacity-0 md:hover:opacity-100 transition  ease-in-out duration-700  absolute w-80'
                    } `}
                >
                    <p className="flex justify-center items-center w-10/12 ml-6 mr-1 py-1 md:py-4 mt-52 mb-56 bg-sm-blue-primary  bg-opacity-50 text-center text-2xl font-bold italic text-white">
                        {sport.title}
                    </p>
                </div>
            </div>
        </Link>
    );
}
